module.exports = __webpack_public_path__ + "img/contract.6948a11e.png";